<template>
  <div class="product-overall-reject">
    <p class="product-overall-reject__hint">
      {{ $t('lbl_EMPBE_ProductInfo_OverallReject_Hint') }}
    </p>
    <FieldRejectionFeedback
      ref="fieldRejectionFeedback"
      :value="displayValue"
      mode="admin"
      :rejected="manuallyActive"
      :templates="templates"
      :actor="actor"
      :rejected-count="rejectedCount"
      @input="$emit('input', $event)"
      @update:rejected="onRejectedUpdate"
    />
  </div>
</template>

<script>
import FieldRejectionFeedback from '@/components/FieldRejectionFeedback/FieldRejectionFeedback.vue';
import { resolveProductRejectReasonText } from './productApprovalFieldMeta';

export default {
  name: 'ProductOverallRejectPanel',
  components: { FieldRejectionFeedback },
  props: {
    /** 审批表 ApprovalDetail.RejectReason */
    value: { type: String, default: '' },
    actor: { type: String, default: '' },
    templates: { type: Array, default: () => [] },
    /** 子项任一勾选时强制总驳回勾选 */
    forceActive: { type: Boolean, default: false },
    /** 已勾选子项数量（总驳回角标） */
    rejectedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      /** 用户是否主动勾选总驳回；默认未勾选 */
      manuallyActive: false,
    };
  },
  computed: {
    displayValue() {
      return resolveProductRejectReasonText(this.value);
    },
  },
  watch: {
    forceActive: {
      immediate: true,
      handler(val) {
        if (val) this.manuallyActive = true;
      },
    },
    value: {
      immediate: true,
      handler(val) {
        const resolved = resolveProductRejectReasonText(val);
        if (resolved && resolved !== String(val || '').trim()) {
          this.$emit('input', resolved);
        }
      },
    },
  },
  methods: {
    ensureActive() {
      this.manuallyActive = true;
    },
    isRejectActive() {
      return this.manuallyActive === true;
    },
    focusReason() {
      this.$nextTick(() => {
        const frf = this.$refs.fieldRejectionFeedback;
        const el = frf && frf.$refs && frf.$refs.reasonInput;
        if (el && typeof el.focus === 'function') el.focus();
      });
    },
    showReasonError(message, options = {}) {
      const shouldScroll = options.scroll !== false;
      this.$nextTick(() => {
        const frf = this.$refs.fieldRejectionFeedback;
        if (frf && typeof frf.showError === 'function') {
          frf.showError(message, { scroll: shouldScroll });
        } else if (shouldScroll) {
          this.focusReason();
        }
      });
    },
    onRejectedUpdate(rejected) {
      this.manuallyActive = !!rejected;
      if (!rejected) {
        this.$emit('input', '');
      } else {
        this.focusReason();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.product-overall-reject {
  display: flex;
  flex-direction: column;
  gap: 4px;
  // width: 100%;
  margin: 0 0 12px;
  padding: 8px;
  border: 1px solid #7366ff;
  border-radius: 16px;
  box-shadow: 0 2px 15px 0 rgba(183, 183, 183, 0.3);
  box-sizing: border-box;
  background: #fff;
  overflow: visible;
}

.product-overall-reject__hint {
  margin: 0;
  padding: 4px;
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  color: rgba(0, 0, 0, 0.8);
}
</style>
